
import { mutations } from '@/assets/scripts/store'
import { bestPicFormat } from '@/assets/scripts/utils'

export default {
  name: 'DetailDrink',

  head() {
    return this.popinData ? this.popinData.metaTags : null
  },

  computed: {
    popinData: mutations.getPopinData,
    pic() {
      return bestPicFormat(this.popinData.pic, [
        'thumbnail',
        'small',
        'medium',
        'origin',
      ])
    },
  },
}
